"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUniswapData = exports.getTokenUserData = exports.getCurrentPoolData = void 0;
var abi_1 = require("@ethersproject/abi");
var multicall_1 = require("@indexed-finance/multicall");
var constants_1 = require("./constants");
var bmath = __importStar(require("./bmath"));
var address_1 = require("./utils/address");
var bignumber_1 = require("./utils/bignumber");
var provider_1 = require("./utils/provider");
function getCurrentPoolData(provider_, pool, tokens, userAddress) {
    return __awaiter(this, void 0, void 0, function () {
        var provider, poolAddress, tokenAddresses, ipoolAbi, iface, multi, calls, _i, tokenAddresses_1, token, response, totalDenorm, totalSupply, swapFee, userBalance, i, chunkResponse, chunk, tokenInfos;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    provider = provider_1.toProvider(provider_);
                    poolAddress = address_1.toAddress(pool);
                    tokenAddresses = [];
                    tokens.forEach(function (t) {
                        tokenAddresses.push(address_1.toAddress(t));
                    });
                    ipoolAbi = require('./abi/IPool.json');
                    iface = new abi_1.Interface(ipoolAbi);
                    multi = new multicall_1.MultiCall(provider);
                    calls = [];
                    calls.push({ target: poolAddress, function: 'getTotalDenormalizedWeight' });
                    calls.push({ target: poolAddress, function: 'totalSupply' });
                    calls.push({ target: poolAddress, function: 'getSwapFee' });
                    if (userAddress) {
                        calls.push({ target: poolAddress, function: 'balanceOf', args: [userAddress] });
                    }
                    for (_i = 0, tokenAddresses_1 = tokenAddresses; _i < tokenAddresses_1.length; _i++) {
                        token = tokenAddresses_1[_i];
                        calls.push({ target: poolAddress, function: 'getBalance', args: [token] });
                        calls.push({ target: poolAddress, function: 'getUsedBalance', args: [token] });
                        calls.push({ target: poolAddress, function: 'getDenormalizedWeight', args: [token] });
                    }
                    return [4 /*yield*/, multi.multiCall(iface, calls)];
                case 1:
                    response = _a.sent();
                    totalDenorm = bmath.bnum(response[0]);
                    totalSupply = bmath.bnum(response[1]);
                    swapFee = bmath.bnum(response[2]);
                    i = 3;
                    if (userAddress) {
                        userBalance = bmath.bnum(response[i++]);
                    }
                    chunkResponse = [];
                    for (; i < response.length; i += 3) {
                        chunk = response.slice(i, i + 3);
                        chunkResponse.push(chunk);
                    }
                    tokenInfos = [];
                    chunkResponse.forEach(function (r, j) {
                        var address = tokenAddresses[j];
                        var balance = bmath.bnum(r[0]);
                        var usedBalance = bmath.bnum(r[1]);
                        var usedDenorm = bmath.bnum(r[2]);
                        if (usedDenorm.eq(0)) {
                            usedDenorm = bmath.MIN_WEIGHT;
                        }
                        tokenInfos.push({
                            address: address,
                            balance: balance,
                            usedBalance: usedBalance,
                            usedWeight: bmath.bdiv(usedDenorm, totalDenorm),
                            usedDenorm: usedDenorm
                        });
                    });
                    return [2 /*return*/, {
                            userBalance: userBalance,
                            totalWeight: totalDenorm,
                            totalSupply: totalSupply,
                            swapFee: swapFee,
                            tokens: tokenInfos
                        }];
            }
        });
    });
}
exports.getCurrentPoolData = getCurrentPoolData;
function getTokenUserData(provider_, src, dst_, tokens) {
    return __awaiter(this, void 0, void 0, function () {
        var provider, ierc20Abi, iface, multi, calls, tokenAddresses, dst, _i, tokenAddresses_2, token, response, ret, i, chunk;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    provider = provider_1.toProvider(provider_);
                    ierc20Abi = require('./abi/IERC20.json');
                    iface = new abi_1.Interface(ierc20Abi);
                    multi = new multicall_1.MultiCall(provider);
                    calls = [];
                    tokenAddresses = [];
                    tokens.forEach(function (t) {
                        tokenAddresses.push(address_1.toAddress(t));
                    });
                    dst = address_1.toAddress(dst_);
                    for (_i = 0, tokenAddresses_2 = tokenAddresses; _i < tokenAddresses_2.length; _i++) {
                        token = tokenAddresses_2[_i];
                        calls.push({ target: token, function: 'allowance', args: [src, dst] });
                        calls.push({ target: token, function: 'balanceOf', args: [src] });
                    }
                    return [4 /*yield*/, multi.multiCall(iface, calls)];
                case 1:
                    response = _a.sent();
                    ret = [];
                    for (i = 0; i < response.length; i += 2) {
                        chunk = response.slice(i, i + 2);
                        ret.push({ allowance: bmath.bnum(chunk[0]), balance: bmath.bnum(chunk[1]) });
                    }
                    return [2 /*return*/, ret];
            }
        });
    });
}
exports.getTokenUserData = getTokenUserData;
function getUniswapData(provider_, tokenA_, tokens, userAddress) {
    return __awaiter(this, void 0, void 0, function () {
        var provider, ierc20Abi, pairAbi, multi, calls, tokenA, tokenAddresses, pairAddresses, response, ethBalance, tokenABalance, i, balance, chunks, incr, pairs, j, chunk, tokenB, pairAddress, token0, balanceB, allowanceA, allowanceB, reservesA, reservesB, rI, _a, reserves0, reserves1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    provider = provider_1.toProvider(provider_);
                    ierc20Abi = require('./abi/IERC20.json');
                    pairAbi = require('./abi/Pair.json');
                    multi = new multicall_1.MultiCall(provider);
                    calls = [];
                    tokenA = address_1.toAddress(tokenA_);
                    tokenAddresses = [];
                    pairAddresses = [];
                    if (userAddress) {
                        calls.push({ target: tokenA, interface: ierc20Abi, function: 'balanceOf', args: [userAddress] });
                    }
                    tokens.forEach(function (t) {
                        var tokenB = address_1.toAddress(t);
                        tokenAddresses.push(tokenB);
                        var pairAddress = address_1.computeUniswapPairAddress(tokenA, tokenB);
                        pairAddresses.push(pairAddress);
                        if (userAddress) {
                            calls.push({ target: tokenB, interface: ierc20Abi, function: 'balanceOf', args: [userAddress] });
                            calls.push({ target: tokenA, interface: ierc20Abi, function: 'allowance', args: [userAddress, constants_1.UNISWAP_ROUTER] });
                            calls.push({ target: tokenB, interface: ierc20Abi, function: 'allowance', args: [userAddress, constants_1.UNISWAP_ROUTER] });
                        }
                        calls.push({ target: pairAddress, interface: pairAbi, function: 'getReserves' });
                    });
                    return [4 /*yield*/, multi.multiCall(calls)];
                case 1:
                    response = _b.sent();
                    i = 0;
                    if (!userAddress) return [3 /*break*/, 3];
                    return [4 /*yield*/, provider.getBalance(userAddress)];
                case 2:
                    balance = _b.sent();
                    tokenABalance = bmath.bnum(response[i++]);
                    ethBalance = bignumber_1.toBN(balance);
                    _b.label = 3;
                case 3:
                    chunks = [];
                    incr = userAddress ? 4 : 1;
                    for (; i <= response.length - incr; i += incr) {
                        chunks.push(response.slice(i, i + incr));
                    }
                    pairs = [];
                    for (j = 0; j < chunks.length; j++) {
                        chunk = chunks[j];
                        tokenB = tokenAddresses[j];
                        pairAddress = pairAddresses[j];
                        token0 = address_1.sortTokens(tokenA, tokenB)[0];
                        balanceB = void 0;
                        allowanceA = void 0;
                        allowanceB = void 0;
                        reservesA = void 0;
                        reservesB = void 0;
                        rI = userAddress ? 3 : 0;
                        if (userAddress) {
                            balanceB = bmath.bnum(chunk[0]);
                            allowanceA = bmath.bnum(chunk[1]);
                            allowanceB = bmath.bnum(chunk[2]);
                        }
                        _a = chunk[rI], reserves0 = _a[0], reserves1 = _a[1];
                        if (token0 == tokenA) {
                            reservesA = bmath.bnum(reserves0);
                            reservesB = bmath.bnum(reserves1);
                        }
                        else {
                            reservesA = bmath.bnum(reserves1);
                            reservesB = bmath.bnum(reserves0);
                        }
                        pairs.push({
                            tokenA: tokenA,
                            tokenB: tokenB,
                            pairAddress: pairAddress,
                            balanceB: balanceB,
                            allowanceA: allowanceA,
                            allowanceB: allowanceB,
                            reservesA: reservesA,
                            reservesB: reservesB
                        });
                    }
                    return [2 /*return*/, {
                            tokenABalance: tokenABalance,
                            ethBalance: ethBalance,
                            pairs: pairs
                        }];
            }
        });
    });
}
exports.getUniswapData = getUniswapData;
